/**
 * 서버 기능 스위치 조회 — 화면이 없는 기능의 버튼을 그리지 않게 한다.
 *
 * 기본값을 **꺼짐**으로 둔다: 응답이 오기 전 잠깐 버튼이 보였다 사라지면
 * 그게 더 나쁜 경험이다(눌렀는데 사라지는 버튼). 서버가 켜졌다고 말할 때만
 * 그린다.
 */

import { useEffect, useState } from 'react'
import { fetchConfig, type ServerConfig } from './api'
import { USE_MOCK } from './config'

const DISABLED: ServerConfig = {
  chat: false,
  coach: false,
  assist: false,
  // 응답 전에는 **경고를 그리지 않는다** — 아직 모르는 것을 "꺼짐" 으로
  // 단정해 힌트를 띄우면 정상 서버에서도 매번 깜빡인다.
  record_persisted: true,
}
/** 목 모드는 전 기능이 켜진 것으로 본다(dev 화면 확인용). */
const MOCK_CONFIG: ServerConfig = {
  chat: true,
  coach: true,
  assist: true,
  record_persisted: true,
}

export function useServerConfig(): ServerConfig {
  const [config, setConfig] = useState<ServerConfig>(
    USE_MOCK ? MOCK_CONFIG : DISABLED,
  )

  useEffect(() => {
    if (USE_MOCK) return
    let cancelled = false
    void fetchConfig()
      .then((c) => {
        if (!cancelled) setConfig(c)
      })
      .catch(() => {
        // 조회 실패 시 **꺼진 상태를 유지**한다 — 동작하지 않는 버튼을
        // 그리는 것보다 없는 편이 낫다.
      })
    return () => {
      cancelled = true
    }
  }, [])

  return config
}
